import { Box, Divider, Paper, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { messageHelper } from 'helpers/messageHelper';
import { toastHelper } from 'helpers/toastHelper';
import usePrevious from 'helpers/usePrevious';
import { get } from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { callApiGetListOfThuMamNon } from 'redux/saga/mam-non/thu-chi/thu-mam-non/getAllThuMamNon';
import { callApiSaveThuMamNon } from 'redux/saga/mam-non/thu-chi/thu-mam-non/saveAllThuMamNon';
import { congdoan_get_list_danh_muc_thu_mam_non, loaded, loading } from '../actions';
import ThuMamNonList from './ThuMamNonList';

function MamNonThuMamNonPage() {
    const theme = useTheme();

    const { control, getValues, watch } = useForm();
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.authenticationReducer.userInfo, {});
    const dmThuMamNons = useSelector((state) => state.commonReducer.dmThuMamNons, []);

    const [thuMamNons, setThuMamNons] = useState([]);
    const [data, setData] = useState(null);

    const watches = watch();
    const values = getValues();
    const prevValues = usePrevious(values);

    useEffect(() => {
        dispatch(congdoan_get_list_danh_muc_thu_mam_non({ mappingFromMamNon: false }));
    }, [dispatch]);

    const getThuMamNons = useCallback(
        (month, year) => {
            setThuMamNons([]);
            setData(null);
            if (userInfo.congDoanId) {
                callApiGetListOfThuMamNon(userInfo.congDoanId, month, year)
                    .then((res) => {
                        setThuMamNons(res.data);
                    })
                    .catch((err) => {
                        messageHelper.showError(err);
                    });
            }
        },
        [userInfo]
    );

    useEffect(() => {
        const isDiff = JSON.stringify(values) !== JSON.stringify(prevValues);
        if (isDiff && values.monthYear) {
            const month = dayjs(values.monthYear).month() + 1;
            const year = dayjs(values.monthYear).year();
            getThuMamNons(month, year);
        }
    }, [values, watches, prevValues, getThuMamNons]);

    const onSubmit = () => {
        if (data && userInfo.congDoanId && values.monthYear) {
            saveAllThuMamNon();
        }
    };

    const saveAllThuMamNon = () => {
        const body = buildBody(data);
        const month = dayjs(values.monthYear).month() + 1;
        const year = dayjs(values.monthYear).year();
        dispatch(loading());
        callApiSaveThuMamNon(userInfo.congDoanId, month, year, body)
            .then((res) => {
                toastHelper.success('Lưu thu mầm non thành công!');
                getThuMamNons(month, year);
            })
            .catch((err) => {
                messageHelper.showError(err);
            })
            .finally(() => {
                dispatch(loaded());
            });
    };

    const buildBody = (data) => {
        return [...data.values()].map((item) => {
            return {
                id: get(item, 'dm.id', undefined),
                amount: Number(item.amount),
                notes: item.notes,
                code: item.code,
                danhMucThuMamNonId: item.dmTMNId,
            };
        });
    };

    return (
        <>
            <Paper elevation={3}>
                <Box p={theme.spacing(0, 3)}>
                    <Typography variant="h6">Thu mầm non</Typography>
                </Box>
                <Divider></Divider>
                <Box p={theme.spacing(1, 1)}>
                    <form>
                        <div className="row m-0">
                            <div className="col-md-3 pr-0">
                                <div className="row mr-0">
                                    <label className="mb-0 col-md-4 fmi-label pr-0" htmlFor="monthYear">
                                        Tháng:
                                    </label>
                                    <div className="col-md-8 p-0">
                                        <Controller
                                            control={control}
                                            id="monthYear"
                                            name="monthYear"
                                            render={(props) => (
                                                <ReactDatePicker
                                                    placeholderText="Chọn tháng"
                                                    onChange={(e) => props.onChange(e)}
                                                    className="form-control chi-mam-non-datepicker"
                                                    dateFormat="MM.yyyy"
                                                    showMonthYearPicker
                                                    locale="vi"
                                                    selected={props.value}
                                                    popperProps={{
                                                        positionFixed: true,
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3"></div>
                            <div className="col-md-3"></div>
                            <div className="col-md-3">
                                <div className="row mx-0 w-100">
                                    <button
                                        type="button"
                                        className={clsx({ 'export-button btn btn-primary mb-1 fmi-toolbar-button': true })}
                                        disabled={data === null}
                                        onClick={onSubmit}
                                    >
                                        Lưu
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Box>
            </Paper>
            {values.monthYear && <ThuMamNonList thuMamNons={thuMamNons} dmThuMamNons={dmThuMamNons} setData={setData} monthYear={values.monthYear} data={data} />}
        </>
    );
}

export default MamNonThuMamNonPage;
